import { flattenObject } from 'helpers/flat';

type Props = {
  errors?: Record<string, any>;
  fieldName?: string;
  index: number;
};

export const useFormErrors = ({ errors = {}, index }: Props) => {
  const hasErrors = Boolean(
    Object.keys(errors).some((key) => key.includes(`timeWindows[${index}]`)) ||
      errors.timeWindows?.[index]
  );
  const getErrorMessage = (errorKey: string) => {
    if (!hasErrors) return '';

    if (errors?.[errorKey]?.message) {
      return errors[errorKey].message;
    }

    // server error from /src/modules/BenchmarkForm/hooks/useProblemsHandler.ts
    return flattenObject(errors)[errorKey] || '';
  };

  return { getErrorMessage, hasErrors };
};
